var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGroupButtonBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icGroupButtonBlue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customised-themes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-colors-dark-mode",
    transform: "translate(-742.000000, -785.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icGroupButtonBlue",
    transform: "translate(742.000000, 785.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "#007FFF",
    x: 0,
    y: 0,
    width: 24,
    height: 20,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-5",
    transform: "translate(12.000000, 9.984363) scale(-1, 1) rotate(90.000000) translate(-12.000000, -9.984363) translate(8.015637, 7.984363)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "0 0 4 4 7.96872558 0.031274425"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroupButtonBlue);
export default __webpack_public_path__ + "static/media/icGroupButtonBlue.fb6efe394bee4432ff7522a4bf0abc97.svg";
export { ForwardRef as ReactComponent };